$(document).ready(function () {

    let menuItem = window.location.href;
    let liMenuTag = $(`header .menu a[href='${menuItem}']`).parent('li');
    $(liMenuTag[0]).addClass('active');

    $('[data-fancybox=""]').fancybox({
        autoFocus: false
    });

    $('.city-link').click(function () {
        location.assign($(this).data('link'));
    });

// mobile_menu

    $('.header__top-line .burger').click(function () {
        $(this).toggleClass('active');
        $('.header__mobile-nav').slideToggle();
        $('body').toggleClass("dark");
    });

    $(document).mouseup(function (e) { // событие клика по веб-документу
        if (!$('.header__top-line').is(e.target) // если клик был не по нашему блоку
            && $('.header__top-line').has(e.target).length === 0 && $('.burger').hasClass('active')) { // и не по его дочерним элементам
            $(".header__mobile-nav").fadeOut(); // скрываем его
            $('body').removeClass("dark");
            $('.header__top-line .burger').removeClass('active');
        }
    });

    $('.header__brands-line .brands-burger').click(function () {
        $(this).closest('.wrapper').find('.brands-menu__list_full').slideToggle();
        $(this).toggleClass('active');
    });

    $('.header__top-line .brands-burger').click(function () {
        $('.header__brands-line').slideToggle().css({
            "z-index": "11000"
        });
    });

// header fix
    var hHeight = $(".header").innerHeight();

    $(window).scroll(function () {
        var top = $(window).scrollTop();
        if (top > 200) {
            $(".header").addClass("header-fix");
            $(".header").addClass("header-fix").addClass("compensate-for-scrollbar");
            $('.header__brands-line').slideUp(0);

            $("#header-top").css({
                'margin-top': hHeight + 'px'
            });
        } else {
            $(".header").removeClass("header-fix");
            $(".header").removeClass("header-fix").removeClass("compensate-for-scrollbar");

            $("#header-top").css({
                'margin-top': '0px'
            });
        }
    });

// sticky close

    $('.sticky__close').click(function () {
        $(this).closest('.sticky').slideUp(300);
    });


    function priceFormat(str) {
        return str.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
    }

    function calcCredit(price) {

        var months = 84;

        var initialPayment = 0;

        var percent = 4.5;

        var downRate = 0.95;

        if (initialPayment === 0) {
            price = price - price * 0.4;
        } else {
            price = price - initialPayment;
        }

        if (price < 0) {
            return 0;
        }

        if (percent === 0) {
            return Math.round($price / $months);
        }

        percent = percent / 12 / 100;

        var fullCreditPrice = Math.round(price * (percent * (Math.pow(1 + percent, months))) / (Math.pow(1 + percent, months) - 1)) * downRate;
        return (Math.ceil(Math.round((fullCreditPrice)) / 100)) * 100;
    }

    function calcCredit(price) {

        var months = 84;

        var initialPayment = 0;

        var percent = 4.5;

        var downRate = 0.95;

        if (initialPayment === 0) {
            price = price - price * 0.4;
        } else {
            price = price - initialPayment;
        }

        if (price < 0) {
            return 0;
        }

        if (percent === 0) {
            return Math.round($price / $months);
        }

        percent = percent / 12 / 100;

        var fullCreditPrice = Math.round(price * (percent * (Math.pow(1 + percent, months))) / (Math.pow(1 + percent, months) - 1)) * downRate;
        return (Math.ceil(Math.round((fullCreditPrice)) / 100)) * 100;
    }

    function calcOneItemPrice() {

        var total = 0;

        var hasDiscount = $('.js-check-credit').is(":checked");
        var hasTradeIn = $('.js-check-tradein').is(":checked");
        var hasUtilization = $('.js-check-util').is(":checked");

        var valTradeIn = parseInt($('.js-check-tradein').val());
        var valUtilization = parseInt($('.js-check-util').val());

        var price_old = parseInt($('#show-price-popup-prices').attr('data-price-old'));
        var price = parseInt($('#show-price-popup-prices').attr('data-price-new'));
        var valDiscount = parseInt($('#show-price-popup-prices').attr('data-range'));
        console.log(price_old);
        console.log(price);
        var staticSum = parseInt(valTradeIn + valUtilization);

        console.log(valDiscount);

        var discount = price_old - price;

        total = price;

        if (hasDiscount === false) {
            total = total + valDiscount;
        }

        if (hasTradeIn === false) {
            total = total + valTradeIn;
        }

        if (hasUtilization === false) {
            total = total + valUtilization;
        }

        if (hasDiscount === false && hasTradeIn === false && hasUtilization === false) {
            total = price_old;
        }

        if (hasDiscount === true && hasTradeIn === true && hasUtilization === true) {
            total = price;
        }

        $('#minimal-price').text(priceFormat(total + ''));
    }

    $(document).ready(function () {
        $('.js-check-credit').click(function () {
            calcOneItemPrice();
        });

        $('.js-check-tradein').click(function () {
            calcOneItemPrice();
        });

        $('.js-check-util').click(function () {
            calcOneItemPrice();
        });
    });


// hidden text

    $('.more-info').slideUp(0);
    $('.more-button').click(function () {
        $(this).closest('.more-parent').addClass('active').find('.more-info').slideDown(500);
        $(this).toggleClass('active');
    });

    $('.more-button_columns').click(function () {
        $(this).closest('.more-parent').addClass('one-col').find('.more-info').slideDown(500);
        $(this).slideUp(0);
    });

// filters-toggle

    $('.filters__tags_full').slideUp(0);
    $('.filters__more').click(function () {
        $('.filters__tags_full').slideToggle(300);
        $(this).toggleClass('active');
    });

// select

    $('.select__field').click(function () {
        $(this).next().slideToggle(300);
    });

// select2

    $('.select2').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        dropdownCssClass: 'select-new-dropdown'
    });

    $('.select2_tradeIn').select2({
        width: '100%',
        dropdownCssClass: 'select-new-dropdown'
    });


    $('#credit-popup .select2').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        dropdownCssClass: 'select-new-dropdown',
        dropdownParent: $('#credit-popup')
    });

    $('#trade-in-popup .select2').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        dropdownCssClass: 'select-new-dropdown',
        dropdownParent: $('#trade-in-popup')
    });


    $('.select2').on('select2:selecting', function (e) {
        $(this).removeClass("error");
    });

    $('.select2_compare').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        dropdownCssClass: 'select-new-dropdown',
        dropdownParent: $('.compare__select-items')
    });


// checkbox

    $('.checkbox input').change(function () {
        $(this).closest(".checkbox").toggleClass('changed');
    });

    $('.checkbox-filter input').change(function () {
        $(this).closest(".checkbox-filter").toggleClass('changed');
    });


// tabs

    $('.simple-tabs__button').click(function () {
        var index = $(this).index();
        var item = $(this).closest('.simple-tabs').find('.simple-tabs__item').eq(index);
        $('.simple-tabs__item').removeClass('active');
        item.addClass('active');
        $('.simple-tabs__button').removeClass('active');
        $(this).addClass('active');
    });


// Quiz tabs

    $('.form-tabs__next').click(function () {
        var inputsGroup = $(this).closest('fieldset');

        if ($(this).hasClass('button_validate')) {

            inputsGroup.find('.select2[name="brand"]').valid();
            inputsGroup.find('.select2[name="model"]').valid();
            inputsGroup.find('.select2[name="version"]').valid();
            if ($(this).hasClass('button_validate-phone')) {
                inputsGroup.find('input[name="phone"]').valid();
            }
        }
        if (inputsGroup.find('input').hasClass('error')) {
            return;
        } else if (inputsGroup.find('.select2').hasClass('error')) {
            return;
        } else {
            $(this).closest('.form-tabs').find('.form-tabs__item').removeClass('form-tabs__item_active');
            $(this).closest('.form-tabs__item').next('.form-tabs__item').addClass('form-tabs__item_active');
        }
    });

    $('.form-tabs__prev').click(function () {
        $('.form-tabs__item').removeClass('form-tabs__item_active');
        $(this).closest('.form-tabs__item').prev().addClass('form-tabs__item_active');
    });

    // ui-range

    $("#term-range").slider({
        animate: "slow",
        range: "min",
        min: 12,
        max: 84,
        step: 12,
        value: 48,
        create: function (event, ui) {
            val = $("#term-range").slider("value");
            $("#term").html(val + " мес");
        },
        slide: function (event, ui) {
            $("#term").html(ui.value + " мес");
            $("#input-term").val(ui.value);
        }
    });

    $("#percent-range").slider({
        animate: "slow",
        range: "min",
        min: 0,
        max: 60,
        step: 10,
        value: 30,
        create: function (event, ui) {
            val = $("#percent-range").slider("value");
            $("#percent").html(val + " %");
        },
        slide: function (event, ui) {
            $("#percent").html(ui.value + " %");
            $("#input-percent").val(ui.value);
        }
    });


// info plate

    $('.hover-info').hover(function () {
        var plate = $(this).find('.hover-info__plate');
        var plateHeight = plate.innerHeight();
        plate.closest('.hover-info').toggleClass("active");
        plate.css({
            'top': 'calc(50% - ' + plateHeight / 2 + 'px)'
        });
    });


// Popup tabs

    $('.tabs.tabs_popup .tabs__buttons .button').on("click touchstart", function () {
        var index = $(this).index();
        var height = $(this).closest('.tabs__item').next('.tabs__item').height();
        $('.tabs.tabs_popup .tabs__content').css({
            'margin-left': '-' + (index + 1) + '00%',
            'height': height + 'px'
        });
    });

    $('.tabs.tabs_popup .tabs__back').on("click touchstart", function () {
        var height = $(this).closest('.tabs__content').find('.tabs__item').eq(0).height();
        $('.tabs.tabs_popup .tabs__content').addClass('active').css({
            'margin-left': '0',
            'height': height + 'px'
        });
    });

// list-toggle

    $('.toggle-list__field').click(function (e) {
        e.preventDefault();
        $(this).closest('.toggle-list').toggleClass('open');
        $(this).toggleClass('active');
        $(this).next().slideToggle(500);
    });

// scroll

    $('.scroll-link').on('click', function () {
        var el = $(this);
        var dest = el.attr('href'); // получаем направление
        if (dest !== undefined && dest !== '') { // проверяем существование
            $('html').animate({
                    scrollTop: $(dest).offset().top - 150 // прокручиваем страницу к требуемому элементу
                }, 500 // скорость прокрутки
            );
        }
        return false;
    });


// colors change

    $('.colors__color-circle').on("click", function () {
        let colorParent = $(this).closest('.colors__color');
        $('.colors__color').removeClass("active");
        colorParent.addClass("active");
        $('.dif-colors__images img').removeClass("active");
        $('.dif-colors__images img[data-id=' + colorParent.data('id') + ']').addClass("active");
    });


// hidden text

    $('.info-block__second-part').slideUp(0);
    // $('.more-info').click(function(event)
    // {
    //     event.preventDefault();
    // 	$(this).closest('.info-block').find('.info-block__second-part').slideDown(500);
    // 	$(this).toggleClass('more-info_active');
    // });


// technical-screen

    // accordion

    $('.inner-page_car .accordion__answer').hide();
    $('.inner-page_modification .accordion__answer').hide();
    $('.accordion__question-caption').click(function () {
        $(this).closest('.accordion__question').toggleClass('active').next().slideToggle(500);
        $(this).toggleClass('active');
    });

    // table accordion

    $('.toggle-line').click(function () {
        $(this).closest('thead').next().toggleClass('hidden');
        $(this).toggleClass('active');
    });

    // compare accordion

    $('.compare__content').hide();
    $('.compare__toggle-line').click(function () {
        $(this).next().slideToggle(500);
        $(this).toggleClass('active');
    });

    $(window).resize();
});
